export const CONFIG = {
    client_name : "sparkasse_offenbach",
    client_display_name : "Sparkasse Offenbach",
    modal_confirm_button_label : "übernehmen",
    country : 'de',
    base_asset_url : `https://esr.fe-bis.de/de/sparkasse_offenbach/`,
    plz_validation : (plz : string) => plz.length == 5,
    plz_default: "12345",
    foerderung : true,
    show_funding_list: true,
    development_mode: false
}